const SvgIcons = () => {
  return (
    <svg
      style={{ width: 0, height: 0, position: 'absolute', zIndex: -1 }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <symbol id="identification" viewBox="0 0 24 24">
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Person-/-User-/-identification-/-24" fill="currentcolor">
            <path
              d="M21,4.5 L21,19.5 L3,19.5 L3,4.5 L21,4.5 M21,3 L3,3 C2.17157288,3 1.5,3.67157288 1.5,4.5 L1.5,19.5 C1.5,20.3284271 2.17157288,21 3,21 L21,21 C21.8284271,21 22.5,20.3284271 22.5,19.5 L22.5,4.5 C22.5,3.67157288 21.8284271,3 21,3 Z M4.5,7.5 L9.75,7.5 L9.75,9 L4.5,9 Z M4.5,10.5 L7.5,10.5 L7.5,12 L4.5,12 Z M17.25,13.5 L12.75,13.5 C11.5073593,13.5 10.5,14.5073593 10.5,15.75 L10.5,17.25 L12,17.25 L12,15.75 C12,15.3357864 12.3357864,15 12.75,15 L17.25,15 C17.6642136,15 18,15.3357864 18,15.75 L18,17.25 L19.5,17.25 L19.5,15.75 C19.5,14.5073593 18.4926407,13.5 17.25,13.5 Z M15,12.75 C16.6568542,12.75 18,11.4068542 18,9.75 C18,8.09314575 16.6568542,6.75 15,6.75 C13.3431458,6.75 12,8.09314575 12,9.75 C12,11.4068542 13.3431458,12.75 15,12.75 Z M15,8.25 C15.8284271,8.25 16.5,8.92157288 16.5,9.75 C16.5,10.5784271 15.8284271,11.25 15,11.25 C14.1715729,11.25 13.5,10.5784271 13.5,9.75 C13.5,8.92157288 14.1715729,8.25 15,8.25 Z"
              id="Fill"
            ></path>
          </g>
        </g>
      </symbol>

      <symbol id="user" viewBox="0 0 24 24">
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Person-/-User-/-user-/-24" fill="currentcolor">
            <path
              d="M12,3 C14.0710678,3 15.75,4.67893219 15.75,6.75 C15.75,8.82106781 14.0710678,10.5 12,10.5 C9.92893219,10.5 8.25,8.82106781 8.25,6.75 C8.25,4.67893219 9.92893219,3 12,3 M12,1.5 C9.10050506,1.5 6.75,3.85050506 6.75,6.75 C6.75,9.64949494 9.10050506,12 12,12 C14.8994949,12 17.25,9.64949494 17.25,6.75 C17.25,5.35761343 16.6968766,4.02225539 15.7123106,3.0376894 C14.7277446,2.05312341 13.3923866,1.5 12,1.5 Z M19.5,21.5 L18,21.5 L18,18.75 C18,17.7554382 17.6049118,16.801611 16.9016504,16.0983496 C16.198389,15.3950882 15.2445618,15 14.25,15 L9.75,15 C7.67893219,15 6,16.6789322 6,18.75 L6,21.5 L4.5,21.5 L4.5,18.75 C4.5,15.8505051 6.85050506,13.5 9.75,13.5 L14.25,13.5 C17.1494949,13.5 19.5,15.8505051 19.5,18.75 L19.5,21.5 Z"
              id="Fill"
            ></path>
          </g>
        </g>
      </symbol>

      <symbol id="checkmark" viewBox="0 0 24 24">
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Organization-/-Status-/-checkmark-/-24" fill="currentcolor">
            <polygon
              id="Fill"
              points="9.75 18 3 11.25 4.0605 10.1895 9.75 15.87825 19.9395 5.6895 21 6.75"
            ></polygon>
          </g>
        </g>
      </symbol>

      <symbol id="purchase" viewBox="0 0 24 24">
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Enterprise-/-Commerce-/-purchase-/-24" fill="currentcolor">
            <path
              d="M21,4.5 L3,4.5 C2.17157288,4.5 1.5,5.17157288 1.5,6 L1.5,18 C1.5,18.8284271 2.17157288,19.5 3,19.5 L21,19.5 C21.8284271,19.5 22.5,18.8284271 22.5,18 L22.5,6 C22.5,5.17157288 21.8284271,4.5 21,4.5 Z M21,6 L21,8.25 L3,8.25 L3,6 L21,6 Z M3,18 L3,9.75 L21,9.75 L21,18 L3,18 Z M4.5,15 L12,15 L12,16.5 L4.5,16.5 Z"
              id="Fill"
            ></path>
          </g>
        </g>
      </symbol>

      <symbol id="next-filled" viewBox="0 0 20 20">
        <title>Actions / Controls / next--filled / 20</title>
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Actions-/-Controls-/-next--filled-/-20" fill="#000000">
            <path
              d="M1.25,10 C1.25,14.8324916 5.16750844,18.75 10,18.75 C14.8324916,18.75 18.75,14.8324916 18.75,10 C18.75,5.16750844 14.8324916,1.25 10,1.25 C5.16750844,1.25 1.25,5.16750844 1.25,10 Z M5,9.375 L12.59375,9.375 L9.10625,5.870375 L10,5 L15,10 L10,15 L9.10625,14.108 L12.59375,10.625 L5,10.625 L5,9.375 Z"
              id="Fill"
            ></path>
            <polygon
              id="Inner-Fill"
              opacity="0"
              points="10 5 9.10625 5.870625 12.59375 9.375 5 9.375 5 10.625 12.59375 10.625 9.10625 14.108125 10 15 15 10"
            ></polygon>
          </g>
        </g>
      </symbol>

      <symbol id="checkmark" viewBox="0 0 20 20">
        <title>Organization / Status / checkmark / 20</title>
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Organization-/-Status-/-checkmark-/-20" fill="#000000">
            <polygon
              id="Fill"
              points="8.125 15 2.5 9.375 3.38375 8.49125 8.125 13.231875 16.61625 4.74125 17.5 5.625"
            ></polygon>
          </g>
        </g>
      </symbol>
      <symbol id="chevron-left" viewBox="0 0 24 24">
        <title>Actions / Navigation / chevron--left / 24</title>
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Actions-/-Navigation-/-chevron--left-/-24" fill="#000000">
            <polygon
              id="Fill"
              points="6.5 12 14 4.5 15.05 5.55 8.6 12 15.05 18.45 14 19.5"
            ></polygon>
          </g>
        </g>
      </symbol>

      <symbol id="close" viewBox="0 0 20 20">
        <title>Actions / Navigation / close / 20</title>
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Actions-/-Navigation-/-close-/-20" fill="currentcolor">
            <polygon
              id="Fill"
              points="15 5.875 14.125 5 10 9.125 5.875 5 5 5.875 9.125 10 5 14.125 5.875 15 10 10.875 14.125 15 15 14.125 10.875 10"
            ></polygon>
          </g>
        </g>
      </symbol>

      <symbol id="checkmark-filled" viewBox="0 0 16 16">
        <title>Organization / Status / checkmark--filled / 16</title>
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="Organization-/-Status-/-checkmark--filled-/-16"
            fill="currentcolor"
          >
            <path
              d="M8,0 C3.581722,0 0,3.581722 0,8 C0,12.418278 3.581722,16 8,16 C12.418278,16 16,12.418278 16,8 C16,5.87826808 15.1571453,3.84343678 13.6568542,2.34314575 C12.1565632,0.842854723 10.1217319,0 8,0 Z M7,10.7954 L4.5,8.2954 L5.2953,7.5 L7,9.2046 L10.705,5.5 L11.50285,6.29295 L7,10.7954 Z"
              id="Fill"
            ></path>
            <polygon
              id="Inner-Fill"
              opacity="0"
              points="7 10.7955 4.5 8.2955 5.2955 7.5 7 9.2045 10.705 5.5 11.5025 6.2925"
            ></polygon>
          </g>
        </g>
      </symbol>

      <symbol id="radio-button--checked" viewBox="0 0 24 24">
        <g
          id="Actions-/-Toggle-/-radio-button--checked"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            fill="#FFFFFF"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <path
            d="M12,0 C15.1825979,0 18.2348448,1.26428208 20.4852814,3.51471863 C22.7357179,5.76515517 24,8.81740212 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M16.65375,8.8425 C16.3237562,8.51458162 15.791003,8.51433909 15.4607108,8.8419569 L10.5,13.7625 L8.53463617,11.8317173 C8.20525517,11.5081319 7.67791935,11.5062605 7.34625,11.8275 C7.34235576,11.8312718 7.33849931,11.8350824 7.33468124,11.8389313 C7.01821226,12.1579524 7.0202812,12.6731189 7.33930235,12.9895879 L10.5,16.125 L16.6529745,10.0267186 C16.9822166,9.69542704 16.9805504,9.16724507 16.65375,8.8425 Z"
            id="Fill"
            fill="#2BA15E"
          ></path>
        </g>
      </symbol>

      <symbol id="radio-button" viewBox="0 0 24 24">
        <g
          id="Actions-/-Toggle-/-radio-button"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            fill="#FFFFFF"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <path
            d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 Z"
            id="Oval"
            fill="currentcolor"
          ></path>
        </g>
      </symbol>
      <symbol id="information" viewBox="0 0 24 24">
        <title>Organization / Status / information / 24</title>
        <g
          id="Icons"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g id="Organization-/-Status-/-information-/-24" fill="#000000">
            <path
              d="M12.75,16.5 L12.75,10.5 L9.75,10.5 L9.75,12 L11.25,12 L11.25,16.5 L9,16.5 L9,18 L15,18 L15,16.5 L12.75,16.5 L12.75,16.5 Z M12,6 C11.3786797,6 10.875,6.50367966 10.875,7.125 C10.875,7.74632034 11.3786797,8.25 12,8.25 C12.6213203,8.25 13.125,7.74632034 13.125,7.125 C13.125,6.50367966 12.6213203,6 12,6 Z M12,22.5 C6.20101013,22.5 1.5,17.7989899 1.5,12 C1.5,6.20101013 6.20101013,1.5 12,1.5 C17.7989899,1.5 22.5,6.20101013 22.5,12 C22.5,14.7847731 21.3937532,17.4554892 19.4246212,19.4246212 C17.4554892,21.3937532 14.7847731,22.5 12,22.5 Z M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z"
              id="Fill"
            ></path>
          </g>
        </g>
      </symbol>

      <symbol id="lang" viewBox="0 0 24 24">
        <g
          id="Tools-/-Technology-/-wikis"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            fill="#FFFFFF"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <path
            d="M12,1.5 C6.20101013,1.5 1.5,6.20101013 1.5,12 C1.5,17.7989899 6.20101013,22.5 12,22.5 C17.7989899,22.5 22.5,17.7989899 22.5,12 C22.5,9.21522686 21.3937532,6.54451077 19.4246212,4.5753788 C17.4554892,2.60624682 14.7847731,1.5 12,1.5 Z M21,11.25 L16.5,11.25 C16.4124516,8.48781461 15.6968493,5.78186317 14.4075,3.3375 C18.0460573,4.33279072 20.6778597,7.4915524 21,11.25 L21,11.25 Z M12,21 C11.8326884,21.0112351 11.6648116,21.0112351 11.4975,21 C9.94371427,18.5221404 9.08138226,15.6735963 9,12.75 L15,12.75 C14.9253856,15.6714929 14.0708685,18.5198833 12.525,21 C12.3502149,21.012265 12.1747851,21.012265 12,21 L12,21 Z M9,11.25 C9.07461441,8.32850708 9.92913152,5.4801167 11.475,3 C11.8089491,2.96247432 12.1460509,2.96247432 12.48,3 C14.0417072,5.47559712 14.9118553,8.32429651 15,11.25 L9,11.25 Z M9.57,3.3375 C8.2884718,5.78373382 7.58058982,8.48958704 7.5,11.25 L3,11.25 C3.32214033,7.4915524 5.95394271,4.33279072 9.5925,3.3375 L9.57,3.3375 Z M3.0375,12.75 L7.5375,12.75 C7.61576923,15.5098228 8.32107795,18.2156435 9.6,20.6625 C5.97323713,19.6566204 3.35537073,16.5002215 3.0375,12.75 Z M14.4075,20.6625 C15.6968493,18.2181368 16.4124516,15.5121854 16.5,12.75 L21,12.75 C20.6778597,16.5084476 18.0460573,19.6672093 14.4075,20.6625 Z"
            id="Fill"
            fill="#151519"
          ></path>
        </g>
      </symbol>

      <symbol id="search" viewBox="0 0 24 24">
        <g
          id="Actions-/-Operations-/-search"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            fill="#FFFFFF"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <path
            d="M22.75,20.689425 L18.085925,16.02535 C20.9133336,12.6309352 20.5707781,7.61300919 17.3083015,4.63432866 C14.0458249,1.65564813 9.01751807,1.76991193 5.893715,4.893715 C2.76991193,8.01751807 2.65564813,13.0458249 5.63432866,16.3083015 C8.61300919,19.5707781 13.6309352,19.9133336 17.02535,17.085925 L21.689425,21.75 L22.75,20.689425 Z M5,10.75 C5,7.02207794 8.02207794,4 11.75,4 C15.4779221,4 18.5,7.02207794 18.5,10.75 C18.5,14.4779221 15.4779221,17.5 11.75,17.5 C8.02379137,17.4958667 5.00413335,14.4762086 5,10.75 Z"
            id="Fill"
            fill="currentcolor"
          ></path>
        </g>
      </symbol>

      <symbol id="view--off" viewBox="0 0 24 24">
        <g
          id="Actions-/-Toggle-/-view--off"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            fill="#FFFFFF"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <g
            id="Group"
            transform="translate(2.22, 8.4)"
            fill="#151519"
            fillRule="nonzero"
          >
            <path
              d="M19.1513335,7.44705354 C18.9783235,7.5457108 18.7731775,7.57150295 18.5811304,7.51874277 C18.3890833,7.46598259 18.2259075,7.33900312 18.1275835,7.16580354 L16.3463335,4.05330354 C15.3107607,4.75350192 14.1684094,5.28098456 12.9638335,5.61517854 L13.514146,8.91705354 C13.5469393,9.1133681 13.5003545,9.31466702 13.3846513,9.47661634 C13.2689481,9.63856565 13.0936163,9.74788251 12.897271,9.78049104 C12.8572838,9.7870347 12.8168513,9.79048244 12.7763335,9.79080392 C12.4099436,9.7902532 12.0975795,9.52506082 12.0375835,9.16361604 L11.496646,5.92174104 C10.3558924,6.08048919 9.19864959,6.08048919 8.05789598,5.92174104 L7.51695848,9.16361604 C7.45684617,9.52576013 7.14343251,9.79116992 6.77633348,9.79080392 C6.73487634,9.79062877 6.69349773,9.78718055 6.65258348,9.78049104 C6.45623813,9.74788251 6.28090637,9.63856565 6.16520317,9.47661634 C6.04949997,9.31466702 6.00291513,9.1133681 6.03570848,8.91705354 L6.58883348,5.61517854 C5.38473621,5.27992487 4.2430223,4.75149433 3.20820848,4.05049104 L1.43258348,7.16580354 C1.2254767,7.5266871 0.765029548,7.65134782 0.404145982,7.44424104 C0.0432624154,7.23713426 -0.0813982996,6.7766871 0.125708482,6.41580354 L2.00070848,3.13455354 C1.34211408,2.56556593 0.736506236,1.93799304 0.191333482,1.25955354 C0.00610366633,1.05274038 -0.0497233419,0.760520143 0.0462231747,0.499989851 C0.142169691,0.239459559 0.374191234,0.0532464428 0.649313299,0.0159688842 C0.924435364,-0.0213086743 1.19764326,0.096448574 1.35945848,0.322053537 C2.91570848,2.24767854 5.63820848,4.54080354 9.77633348,4.54080354 C13.9144585,4.54080354 16.6369585,2.24486604 18.1932085,0.322053537 C18.3532454,0.0917323749 18.628416,-0.0300517606 18.9065049,0.00636502718 C19.1845939,0.0427818149 19.4191274,0.231313611 19.5144622,0.495076646 C19.6097969,0.75883968 19.5500007,1.0537543 19.3594585,1.25955354 C18.8142857,1.93799304 18.2086779,2.56556593 17.5500835,3.13455354 L19.4250835,6.41580354 C19.5267507,6.58857209 19.555023,6.79485051 19.5035906,6.98860269 C19.4521582,7.18235488 19.3253021,7.34745379 19.1513335,7.44705354 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol id="view" viewBox="0 0 24 24">
        <g
          id="Actions-/-Toggle-/-view"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <rect
            fill="#FFFFFF"
            opacity="0"
            x="0"
            y="0"
            width="24"
            height="24"
          ></rect>
          <g
            id="eye-2"
            transform="translate(0.7, 4.5)"
            fill="#151519"
            fillRule="nonzero"
          >
            <path
              d="M22.4353035,7.19625 C22.402491,7.1221875 21.6084285,5.360625 19.843116,3.5953125 C17.4909285,1.243125 14.519991,0 11.249991,0 C7.97999102,0 5.00905352,1.243125 2.65686602,3.5953125 C0.891553523,5.360625 0.0937410226,7.125 0.0646785226,7.19625 C-0.0215595075,7.39022177 -0.0215595075,7.61165323 0.0646785226,7.805625 C0.0974910226,7.8796875 0.891553523,9.6403125 2.65686602,11.405625 C5.00905352,13.756875 7.97999102,15 11.249991,15 C14.519991,15 17.4909285,13.756875 19.843116,11.405625 C21.6084285,9.6403125 22.402491,7.8796875 22.4353035,7.805625 C22.5215416,7.61165323 22.5215416,7.39022177 22.4353035,7.19625 Z M11.249991,13.5 C8.36436602,13.5 5.84342852,12.4509375 3.75655352,10.3828125 C2.90028362,9.5312756 2.17179187,8.56026905 1.59374102,7.5 C2.17163624,6.4396309 2.90014403,5.46860297 3.75655352,4.6171875 C5.84342852,2.5490625 8.36436602,1.5 11.249991,1.5 C14.135616,1.5 16.6565535,2.5490625 18.7434285,4.6171875 C19.6013665,5.46839901 20.3314503,6.43942299 20.9109285,7.5 C20.234991,8.761875 17.2903035,13.5 11.249991,13.5 Z M11.249991,3 C8.76470965,3 6.74999102,5.01471863 6.74999102,7.5 C6.74999102,9.98528137 8.76470965,12 11.249991,12 C13.7352724,12 15.749991,9.98528137 15.749991,7.5 C15.7474073,5.01578961 13.7342014,3.00258368 11.249991,3 Z M11.249991,10.5 C9.59313677,10.5 8.24999102,9.15685425 8.24999102,7.5 C8.24999102,5.84314575 9.59313677,4.5 11.249991,4.5 C12.9068453,4.5 14.249991,5.84314575 14.249991,7.5 C14.249991,8.29564947 13.9339205,9.05871121 13.3713114,9.62132034 C12.8087022,10.1839295 12.0456405,10.5 11.249991,10.5 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </symbol>
    </svg>
  )
}

export default SvgIcons
